import React from 'react';
import MenuCartAction from './MenuCartAction';
import MenuPlanAction from './MenuPlanAction';

/**
 * Our Menu CTAs: Add to cart + Add to plan on every surface.
 * Variable items open the shared details sheet via onOpenOptions (with cart/plan intent).
 */
export default function MenuItemActions({
  item,
  orderable = true,
  unavailableLabel = 'Unavailable',
  variant = 'card',
  className = '',
  addedClassName = '',
  planClassName = '',
  onAfterAdd,
  onOpenOptions,
  selectedVariant = null,
  /** When 'plan', emphasize Add to Plan (e.g. modal opened from plan CTA). */
  primaryAction = 'cart',
}) {
  if (!orderable && variant !== 'modal') {
    return (
      <div className={`menu-item-actions menu-item-actions--${variant}`}>
        <button
          type="button"
          className={`${className} menu-item__cta--oos`.trim()}
          disabled
          aria-disabled="true"
        >
          {unavailableLabel}
        </button>
      </div>
    );
  }

  const cart = (
    <MenuCartAction
      key="cart"
      item={item}
      orderable={orderable}
      unavailableLabel={unavailableLabel}
      variant={variant}
      className={className}
      addedClassName={addedClassName}
      onAfterAdd={onAfterAdd}
      onOpenOptions={onOpenOptions}
      selectedVariant={selectedVariant}
    />
  );

  const plan = orderable ? (
    <MenuPlanAction
      key="plan"
      item={item}
      orderable
      variant={variant}
      className={planClassName}
      onOpenOptions={onOpenOptions}
      selectedVariant={selectedVariant}
      onAfterAdd={onAfterAdd}
    />
  ) : null;

  const actions = primaryAction === 'plan' ? [plan, cart] : [cart, plan];

  return (
    <div
      className={`menu-item-actions menu-item-actions--${variant}${
        primaryAction === 'plan' ? ' menu-item-actions--primary-plan' : ''
      }`}
    >
      {actions.filter(Boolean)}
    </div>
  );
}
